
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../actions/actions';

class Delete extends React.Component {
    constructor(props) {
        super(props);
        this.deletePage = this.deletePage.bind(this);
    }

    deletePage(e) {
        e.preventDefault();
        this.props.buttonSecondary();
        // TODO refactor
        setTimeout(() => {
            if (this.props.modal.type === 'DELETE_WIDGET') {
                this.props.actions.deleteWidget(this.props.id);
            } else {
                this.props.actions.deletePageAndSetActive(this.props.id);
            }
        }, 400);
    }

    render() {
        const { buttonSecondary, modal } = this.props;

        return (
            <div>
                <header className="modal-header">
                    <h3> {modal.header} </h3>
                </header>
                <div className="modal-body">
                    <p> {modal.msg} </p>
                </div>
                <div className="modal-buttons">
                    <a className="modal-buttons__button cancel-button" onClick={buttonSecondary}>Cancel</a>
                    <button className="modal-buttons__button confirm-button" onClick={this.deletePage}>OK</button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    modal: state.modal,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

Delete.propTypes = {
    app: PropTypes.object.isRequired,
    modal: PropTypes.object.isRequired,
    id: PropTypes.number.isRequired,
    buttonSecondary: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Delete);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Modals/Delete.jsx